import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./manageOrganization.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  allocateMaterial,
  getUnitAPI,
  getUserApi,
  getRoleAPI,
  getPurchasedItem,
  updateallocateMaterial,
} from "api";
import { values } from "lodash";
import moment from "moment";
import { withTranslation } from "react-i18next";

class AllocateMaterial extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      validation: "",
      factoryList: [],
      userList: [],
      userNameList: [],
      materialList: [],
      maxQuantity: 50,
      purchasedItemId: props?.location?.query
        ? props?.location?.query?.data.purchasedItemId
        : "",
      userId:
        props?.location?.query?.isEdit == true
          ? props?.location?.query?.data.userId
          : "",
      roleId:
        props?.location?.query?.isEdit == true
          ? props?.location?.query?.data.user.roleId
          : "",

      props: props?.location?.query
        ? props?.location?.query
        : { isEdit: false, data: null },
      factoryId: "",
      piecesQuantity: null,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async componentDidMount() {
    const factory = await getUnitAPI({ isInternal: true });
    if (factory && factory.data) {
      this.setState({
        factoryList: factory.data.factories,
      });
    }

    this.getFactoryId({ target: { value: "" } });
    const userRole = await getRoleAPI();
    if (userRole && userRole.data) {
      this.setState({
        roleList: userRole.data,
      });
    }
    const material = await getPurchasedItem({
      piecesQuantity: this.state.props.isEdit == true ? null : "0",
      page: null,
      limit: null,
      factoryId: null,
    });
    if (material && material.data) {
      this.setState({
        materialList: material.data.purchasedItems,
      });
    }

    this.getUserList();
  }
  getFactoryId = async e => {};
  async getUserList() {
    const usersName = await getUserApi({
      page: 1,
      limit: 5,
      roleId: this.state.roleId,
      factoryId: this.state.factoryId,
    });
    if (usersName && usersName.data) {
      this.setState({
        userNameList: usersName.data.users,
      });
    }
  }
  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit != true) {
      const data = await allocateMaterial(values);
    } else {
      let id = this.state.props.data.id;
      const data = await updateallocateMaterial({ data: values, id: id });
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "manage organization";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Row>
              <Col xl="12">
                <Formik
                  enableReinitialize={true}
                  initialValues={
                    this.state.props.data == null
                      ? {
                          userId: this.state.userId,
                          purchasedItemId:
                            (this.state && this.state.purchasedItemId) || "",
                          quantity: (this.state && this.state.quantity) || "",
                        }
                      : {
                          userId: this.state.userId,
                          purchasedItemId:
                            this.state.props.data.purchasedItemId,
                          quantity: this.state.props.data.quantity,
                        }
                  }
                  validationSchema={Yup.object().shape({
                    userId: Yup.string().required("This value is Required"),
                    purchasedItemId: Yup.string().required(
                      "This value is Required"
                    ),

                    quantity: Yup.number()
                      .min(1)
                      .max(
                        (() => {
                          if (this.state.props.isEdit == true) {
                            return this.state.materialList.length
                              ? this.state.materialList.filter(
                                  x => x.id === this.state.purchasedItemId
                                )[0].piecesQuantity -
                                  this.state.materialList.filter(
                                    x => x.id === this.state.purchasedItemId
                                  )[0].inUse +
                                  this.state.props.data.quantity
                              : 0;
                          } else {
                            return this.state.materialList.length &&
                              this.state.purchasedItemId
                              ? this.state.materialList.filter(
                                  x => x.id === this.state.purchasedItemId
                                )[0].piecesQuantity -
                                  this.state.materialList.filter(
                                    x => x.id === this.state.purchasedItemId
                                  )[0].inUse
                              : 0;
                          }
                        })()
                      )
                      .required("This value is Required"),
                  })}
                  onSubmit={values => {}}
                >
                  {({ errors, status, touched, values, validateForm }) => (
                    <Form className="needs-validation">
                      <Row>
                        <Col xl="6" lg="12" className="py-3">
                          <Breadcrumbs
                            breadcrumbItem={this.props.t("ALLOCATE MATERIAL")}
                          />
                        </Col>
                        <Col
                          xl="6"
                          lg="12"
                          className="text-start text-xl-end pt-4 pt-lg-0"
                        >
                          <div className="search-box me-2 mb-2 d-inline-block">
                            <div className="position-relative">
                              <label
                                htmlFor="search"
                                className="pt-2 fs-5 pe-1 pe-lg-3"
                              >
                                {this.props.t("Search Factory(Unit) Name")}
                              </label>
                              <select
                                id="factoryId"
                                className="select-field"
                                onChange={e => this.getFactoryId(e)}
                              >
                                <option value="">All</option>
                                {this.state.factoryList?.map(x => (
                                  <option key={x.id} value={x.id}>
                                    {x.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Card>
                          <CardBody>
                            <div>
                              <h4 className="text-black fw-bold mb-4">
                                {this.props.t("ALLOCATE MATERIAL")}
                              </h4>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="purchasedItemId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Item Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  onChange={e => {
                                    this.setState({
                                      purchasedItemId: e.target.value,
                                    });
                                  }}
                                  value={this.state.purchasedItemId}
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.purchasedItemId &&
                                    touched.purchasedItemId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="purchasedItemId"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.materialList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {moment(x.createdAt).format("DD/MM/YYYY")}{" "}
                                      &gt; {x.item.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="purchasedItemId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="userRole"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Role")}
                                </h5>
                              </label>
                              <div className="col-md-10">
                                <select
                                  className="form-control fs-5"
                                  value={this.state.roleId}
                                  onChange={e =>
                                    this.setState(
                                      {
                                        userId: "",
                                        roleId: e.target.value,
                                        userNameList: [],
                                      },
                                      () => this.getUserList()
                                    )
                                  }
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.roleList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="userId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.userId && touched.userId
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="userId"
                                  value={this.state.userId}
                                  onChange={e => {
                                    this.setState({
                                      userId: e.target.value,
                                    });
                                  }}
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  {this.state.userNameList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="userId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <Label
                                htmlFor="quantity"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Allocate Quantity")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.quantity && touched.quantity
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="quantity"
                                  placeholder="01"
                                />
                                <ErrorMessage
                                  name="quantity"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 text-end">
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                                onClick={() => {
                                  validateForm()
                                    .then(data => {
                                      if (Object.keys(data).length == 0) {
                                        this.handleSubmit(event, values);
                                      }
                                    })
                                    .catch(err => console.log(err));
                                }}
                              >
                                {this.state.props.isEdit == true
                                  ? "Update"
                                  : "Submit"}
                              </Button>
                            </div>
                          </CardBody>
                        </Card>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(AllocateMaterial);
